export var Version;

(function (Version) {
  Version["GAODE1.x"] = "GAODE1.x";
  Version["GAODE2.x"] = "GAODE2.x";
  Version["MAPBOX"] = "MAPBOX";
  Version["DEFAULT"] = "DEFAUlTMAP";
  Version["SIMPLE"] = "SIMPLE";
  Version["GLOBEL"] = "GLOBEL";
})(Version || (Version = {}));